import React, { FC } from 'react';

import { formatFromISO } from 'src/utils/dateTimeConverters';
import { IMinHeightGraphContainer } from 'src/@infringements/interfaces';
import { BlockHeader, LineGraph, Card } from '@ems/client-design-system';
// Reducers
import { useConfigSelectors } from 'src/app/reducers';
// Constants
import { THEME_DEFAULT_COLOR, THEME_DEFAULT_OPERATION_TYPE } from 'src/constants';
// Utils
import { getOperationTheme } from 'src/utils';

export const MinHeightGraphContainer: FC<IMinHeightGraphContainer> = ({
  scatterData,
  infringementData,
  title,
  time,
  operationData,
  ruleData,
  type,
  selectedTrackTheme,
}) => {
  const configSelectors = useConfigSelectors();
  const units = configSelectors.getUnits();
  const hasProfile: boolean =
    operationData && operationData.profile && !!Object.keys(operationData.profile).length;
  const operationType: string = hasProfile
    ? operationData.operationType.toLowerCase()
    : THEME_DEFAULT_OPERATION_TYPE;
  const currentTheme = getOperationTheme(selectedTrackTheme);
  const lineColor = currentTheme[operationType.toLowerCase()] || THEME_DEFAULT_COLOR;

  return (
    <div className="block">
      <Card>
        <div>
          <BlockHeader
            title={`${title}`}
            cta={
              time && (
                <span className="infringements_time">{formatFromISO(time, 'HH:mm, DDD')}</span>
              )
            }
            loading={!hasProfile}
          />
          {hasProfile ? (
            <LineGraph
              scatterData={scatterData ? scatterData : operationData.profile}
              infringementData={infringementData}
              maxYValue={5000}
              type={type}
              stepSizeY={1000}
              stepSizeX={5000}
              lineValue={ruleData.requiredAltitude}
              flightDistance={ruleData.flightDistance}
              lineColor={lineColor}
              units={units}
            />
          ) : (
            <div className="graph--loading" />
          )}
        </div>
      </Card>
    </div>
  );
};
